import React, { Component } from 'react'
import { Provider } from 'react-redux'
import {configureStore} from '../redux/configureStore'
import App from './App'
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import ReactGA from 'react-ga4'
import { history } from './history';
import { HelmetProvider } from 'react-helmet-async';
import CssBaseline from '@mui/material/CssBaseline';

const isJobHunt = (window.VIEW_TYPE === 'journey' || window.location.hostname === 'dashboard.jobhunt.co.il' || window.location.hostname === 'devdashboard.jobhunt.co.il')
//const isJobHunt = true

const theme = createTheme({
    components: {
        MuiGrid: {
          styleOverrides: {
            root: {
              // Removes the global negative margin bug on all grid containers
              marginTop: '0px !important',
            },
          },
        },
    },
    palette: {
        primary: {
            main: '#396a92',
        },
        secondary: {
            main: '#fbbc04'
        }
    }
});

const themeJH = createTheme({
    components: {
        MuiGrid: {
          styleOverrides: {
            root: {
              // Removes the global negative margin bug on all grid containers
              marginTop: '0px !important',
            },
          },
        },
    },
    typography: {
        fontFamily: [
            'DM Sans',
            'sans-serif'
        ].join(','),
    },
    palette: {
        primary: {
            main: '#aa4dc8',
        },
        secondary: {
            main: '#fbbc04'
        }
    }
});

const themeJourney = createTheme({
    typography: {
        fontFamily: 'DM Sans, sans-serif',
    },
    components: {
        MuiGrid: {
            styleOverrides: {
              root: {
                // Removes the global negative margin bug on all grid containers
                marginTop: '0px !important',
              },
            },
        },
        MuiCssBaseline: {
            styleOverrides: `
            @font-face {
                font-family: 'DM Sans';
                font-style: italic;
                font-weight: 100 1000;
                font-display: swap;
                src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Fp2ywxg089UriCZa4ET-DNl0.woff2) format('woff2');
                unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
            }
            `,
        },
    },
    palette: {
        primary: {
            main: '#6366f1',
        },
        secondary: {
            main: '#fbbc04'
        }
    }
});

const store = configureStore()

const GAID = (window.location.hostname==='jobswipe.co' || window.location.hostname==='journey.jobhunt.co.il') ?'G-KPZDF6XWV7' : 'G-9BBGEKZBKF';
const themeToUse = (window.VIEW_TYPE === 'journey') ? themeJourney : (isJobHunt?themeJH:theme)

ReactGA.initialize(GAID/*, {
    gtagOptions: {
      debug_mode: true
    }}*/
)

/*history.listen((location, action) => {
    if (location.pathname.startsWith('/jobs')){
        ReactGA.set({ page: location.pathname })
        ReactGA.pageview(location.pathname)
    }
})*/

export default class Root extends Component {
    render() {
        return (
            <HelmetProvider>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={themeToUse}>
                    <Provider store={store}>
                        <CssBaseline />
                        <App history={history} isJobHunt={isJobHunt}/>
                    </Provider>
                    </ThemeProvider>
                </StyledEngineProvider>
            </HelmetProvider>
        );
    }
}